import Box from "@mui/material/Box"
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import { useNavigate } from "react-router-dom";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";

const HeroSlanting = () => {
    const navigate = useNavigate();
    const theme = useTheme();
    const mobileScreen = useMediaQuery(theme.breakpoints.down("sm"));

    const heroCurvedStyle = {
        position: "relative",
        minHeight: '75vh',
        backgroundImage: "linear-gradient(0deg, #412C6C 0%, #6d4cb1 100%)",
        // clipPath: `polygon(0 0, 100% 0, 100% 100%, 0 calc(100% - 5vw))`,
        clipPath: `ellipse(171% 100% at 79% 0%)`,
        marginTop: { xl: '0.5rem', lg: '0.5rem', md: '0.5rem', sm: '0.5rem', xs: '0' },
        display: 'flex',
        justifyContent: {
            xl: 'space-around',
            lg: 'space-around',
            md: 'space-around',
            sm: 'space-between',
            xs: 'space-between',
        },
        alignItems: 'center',
        height: '100%',
        padding: {
            xl: "4rem 8rem 4rem 8rem",
            lg: "6rem 6rem 5rem 6rem",
            md: "4rem 4rem 5rem 4rem",
            sm: "2rem 2rem 5rem 2rem",
            xs: "1rem 1rem 5rem 1rem"
        },
    }

    const h1Style = {
        color: "#FFFFFF",
        fontWeight: 600,
        fontSize: { xl: "42px", lg: "42px", md: "42px", sm: "38px", xs: "32px" },
        fontFamily: "Roboto",
        lineHeight: "normal",
        letterSpacing: "1.5px",
        textShadow: "#381b72 1px 0 5px"
    };

    return (
        <Box sx={heroCurvedStyle}>
            {!mobileScreen &&
                <>
                    <Box sx={{
                        position: 'absolute',
                        top: '25.5vh',
                        left: 0,
                        minHeight: '15rem',
                        minWidth: '15rem',
                        backgroundImage: `linear-gradient(0deg, #FFC107 0%, #FFE16A 100%)`,
                        boxShadow: 'inset #B78103 0px 0px 60px -12px',
                        clipPath: `circle(40% at 0%)`,
                        display: {
                            xl: 'block',
                            lg: 'block',
                            md: 'block',
                            sm: 'none',
                            xs: 'none',
                        }
                    }}></Box>
                    <Box sx={{
                        position: 'absolute',
                        top: '25.5vh',
                        left: 0,
                        minHeight: '5rem',
                        minWidth: '5rem',
                        backgroundImage: `linear-gradient(0deg, #D6E4FF 0%, #FEFEFE 100%)`,
                        boxShadow: 'inset #D0F2FF 0px 0px 60px -12px',
                        clipPath: `circle(30% at 60%)`,
                        display: {
                            xl: 'block',
                            lg: 'block',
                            md: 'block',
                            sm: 'none',
                            xs: 'none',
                        }
                    }}></Box>
                    <Box sx={{
                        position: 'absolute',
                        bottom: '0',
                        right: '0',
                        maxHeight: '25rem',
                        minWidth: '2rem',
                        zIndex: '-1',
                        display: {
                            xl: 'block',
                            lg: 'block',
                            md: 'block',
                            sm: 'none',
                            xs: 'none',
                        }
                    }}>
                        <img src="/circle.webp" style={{ width: '100%', height: '100%', maxHeight: 'inherit' }} loading="lazy" />
                    </Box>
                </>
            }

            <Box sx={{
                width: {
                    xl: '50%',
                    lg: '55%',
                    md: '70%',
                    sm: '100%',
                    xs: '100%'
                },
                height: "100%",
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
            }}>
                <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column', rowGap: 2 }}>
                    <Typography sx={h1Style}>
                        Revolutionize Your Academic Writing Workflow With ACADLANCE
                    </Typography>
                    <Typography variant="h6" sx={{ width: '100%', color: '#FEFEFE', fontSize: '1.5rem' }}>
                        Upgrade your academic expedition!
                    </Typography>
                    <Typography variant="p" sx={{ width: '100%', color: '#FEFEFE', fontSize: '1.125rem' }}>
                        Our platform is a perfect blend for both experts and clients!  Experts can showcase their skills and secure fair pay, while clients can access top-tier experts and streamline projects effortlessly.
                    </Typography>
                    <Button size="large" variant="contained"
                        onClick={() => navigate("/signup")}
                        sx={{
                            fontWeight: '600',
                            backgroundColor: '#FEFEFE',
                            color: '#6d4cb1',
                            marginTop: 1,
                            marginBottom: 2,
                            width: 'max-content',
                            '&:hover': {
                                color: 'white',
                                backgroundColor: '#6d4cb1'
                            }
                        }}>
                        Get Started
                    </Button>
                </Box>
            </Box>
            {!mobileScreen &&
                <Box sx={{
                    justifyContent: 'flex-end',
                    maxWidth: {
                        xl: '55%',
                        lg: '40%',
                        md: '0',
                        sm: '0',
                        xs: '0'
                    },
                    maxHeight: '75vh',
                    display: {
                        xl: 'flex',
                        lg: 'flex',
                        md: 'none',
                        sm: 'none',
                        xs: 'none',
                    }
                }}>
                    <img src="/womanlaptop.webp" style={{ width: '100%', height: '100%', maxHeight: 'inherit', marginTop: '-4rem', }} />
                </Box>
            }
        </Box >
    )
}

export default HeroSlanting